// Import dependencies
import { useEffect, useState } from "react";
import { db } from "./Firebase";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  addDoc,
} from "firebase/firestore";
import { Delete, PersonAdd, FileDownload } from "@mui/icons-material";
import Navbar from "./Navbar";
import { motion } from "framer-motion";
import Modal from "react-modal";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";

Modal.setAppElement("#root");

export default function Users() {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterRole, setFilterRole] = useState("All");
  const [visibleCount, setVisibleCount] = useState(6);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newUser, setNewUser] = useState({ Name: "", Email: "", Contact: "", Role: "User" });

  const usersCollectionRef = collection(db, "Users");

  const getData = async () => {
    const snapshot = await getDocs(usersCollectionRef);
    const userData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setData(userData);
  };

  useEffect(() => {
    getData();
  }, []);

  const deleteUser = async (id) => {
    await deleteDoc(doc(db, "Users", id));
    getData();
  };

  const handleSearch = (e) => setSearchQuery(e.target.value);

  const handleExportPDF = () => {
    const doc = new jsPDF();
    data.forEach((user, i) => {
      doc.text(
        `Name: ${user.Name}, Email: ${user.Email}, Contact: ${user.Contact}, Role: ${user.Role}`,
        10,
        10 + i * 10
      );
    });
    doc.save("users.pdf");
  };

  const handleExportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
    XLSX.writeFile(workbook, "users.xlsx");
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleAddUser = async () => {
    if (!newUser.Name || !newUser.Email) return;
    await addDoc(usersCollectionRef, newUser);
    closeModal();
    getData();
    setNewUser({ Name: "", Email: "", Contact: "", Role: "User" });
  };

  const filteredData = data.filter((user) => {
    const match =
      user.Name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.Email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.Contact?.includes(searchQuery);
    return filterRole === "All" ? match : match && user.Role === filterRole;
  });

  return (
    <>
      <Navbar />
      <div className="dashboard-bg px-3 mt-5 py-5" style={{ background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)', minHeight: '100vh', color: '#f0f0f0' }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-bold">User Management</h2>
          <div className="d-flex gap-2">
            <button className="btn btn-outline-light" onClick={handleExportPDF}><FileDownload /> PDF</button>
            <button className="btn btn-outline-success" onClick={handleExportExcel}><FileDownload /> Excel</button>
            <button className="btn btn-info text-white" onClick={openModal}><PersonAdd /> Add User</button>
          </div>
        </div>

        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
          <input
            type="text"
            className="form-control w-50"
            placeholder="Search by name, email, or phone"
            value={searchQuery}
            onChange={handleSearch}
            style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid #555', color: '#fff' }}
          />

         
        </div>

        <div className="row">
          {filteredData.slice(0, visibleCount).map((user) => (
            <motion.div
              key={user.id}
              className="col-xl-3 col-lg-4 col-md-6 mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <div className="card bg-dark border border-light shadow-lg p-3 rounded-4 h-100">
                <div className="card-body">
                  <h5 className="card-title text-info">{user.Name}</h5>
                  <p className="text-light"><strong>Email:</strong> {user.Email}</p>
                  <p className="text-light"><strong>Phone:</strong> {user.Contact}</p>
                  {/* <p className="text-light"><strong>Role:</strong> <span className={`badge bg-${user.Role === 'Admin' ? 'danger' : 'secondary'}`}>{user.Role}</span></p> */}
                  <button className="btn btn-sm btn-outline-danger mt-2" onClick={() => deleteUser(user.id)}><Delete fontSize="small" /> Delete</button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {visibleCount < filteredData.length && (
          <div className="text-center mt-4">
            <button className="btn btn-outline-light" onClick={() => setVisibleCount(visibleCount + 6)}>
              Load More
            </button>
          </div>
        )}
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="Modal"
        overlayClassName="Overlay"
      >
        <div style={{ background: '#1e272e', color: '#f1f1f1', padding: '20px', borderRadius: '10px' }}>
          <h3 className="mb-3">Add New User</h3>
          <input type="text" placeholder="Name" className="form-control mb-2" value={newUser.Name} onChange={(e) => setNewUser({ ...newUser, Name: e.target.value })} />
          <input type="email" placeholder="Email" className="form-control mb-2" value={newUser.Email} onChange={(e) => setNewUser({ ...newUser, Email: e.target.value })} />
          <input type="text" placeholder="Phone" className="form-control mb-2" value={newUser.Contact} onChange={(e) => setNewUser({ ...newUser, Contact: e.target.value })} />
          <select className="form-select mb-3" value={newUser.Role} onChange={(e) => setNewUser({ ...newUser, Role: e.target.value })}>
            <option value="User">User</option>
            <option value="Admin">Admin</option>
          </select>
          <div className="d-flex justify-content-end">
            <button className="btn btn-secondary me-2" onClick={closeModal}>Cancel</button>
            <button className="btn btn-success" onClick={handleAddUser}>Add</button>
          </div>
        </div>
      </Modal>
    </>
  );
}
// import { useEffect, useState } from "react";
// import { db } from "./Firebase";
// import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
// import { Delete } from "@mui/icons-material";
// import Navbar from "./Navbar";
// import { motion } from "framer-motion";

// export default function Users() {
//   const [data, setData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const usersCollectionRef = collection(db, "Users");

//   const getData = async () => {
//     try {
//       const snapshot = await getDocs(usersCollectionRef);
//       const userData = snapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setData(userData);
//     } catch (err) {
//       console.error("Error fetching data:", err);
//     }
//   };

//   useEffect(() => {
//     getData();
//   }, []);

//   const deleteUser = async (id) => {
//     try {
//       await deleteDoc(doc(db, "Users", id));
//       getData();
//     } catch (error) {
//       console.error("Error deleting user: ", error);
//     }
//   };

//   const handleSearch = (e) => setSearchQuery(e.target.value);

//   const filteredData = data.filter((user) =>
//     [user.Name, user.Email, user.Contact].some((field) =>
//       field?.toLowerCase().includes(searchQuery.toLowerCase())
//     )
//   );

//   return (
//     <>
//       <Navbar />
//       <div className="container-fluid py-5 px-3 dashboard-bg">
//         <h2 className="text-center display-5 text-white mb-4 fw-semibold">User Directory</h2>

//         <div className="d-flex justify-content-center mb-4">
//           <input
//             type="text"
//             className="search-input"
//             placeholder="Search by name, email, or phone"
//             value={searchQuery}
//             onChange={handleSearch}
//           />
//         </div>

//         <div className="row justify-content-center">
//           {filteredData.length > 0 ? (
//             filteredData.map((user) => (
//               <motion.div
//                 key={user.id}
//                 className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4"
//                 initial={{ opacity: 0, y: 30 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.4 }}
//               >
//                 <div className="user-card glass-effect p-4 text-light">
//                   <div className="d-flex align-items-center mb-3">
//                     {user.photoURL ? (
//                       <img src={user.photoURL} alt="profile" className="avatar" />
//                     ) : (
//                       <div className="avatar text-white bg-secondary">
//                         {user.Name?.charAt(0)?.toUpperCase() || "U"}
//                       </div>
//                     )}
//                     <div className="ms-3">
//                       <h5 className="fw-semibold m-0">{user.Name}</h5>
//                       <span className="text-light small">{user.Email}</span>
//                     </div>
//                   </div>

//                   <p><strong>Phone:</strong> {user.Contact}</p>
//                   <p><strong>Address:</strong> {user.Address}</p>
//                   <p><strong>Gender:</strong> {user.Gender}</p>
//                   <p><strong>DOB:</strong> {user.Dateofbirth}</p>

//                   <button className="btn-delete" onClick={() => deleteUser(user.id)}>
//                     <Delete fontSize="small" /> Delete
//                   </button>
//                 </div>
//               </motion.div>
//             ))
//           ) : (
//             <p className="text-center text-white">No users found</p>
//           )}
//         </div>
//       </div>

//       <style jsx>{`
//         .dashboard-bg {
//           // background: linear-gradient(135deg, #141e30, #243b55);
//           background: linear-gradient(135deg,rgb(0, 0, 0),rgb(19, 35, 41), #2c5364);

//           min-height: 100vh;
//         }

//         .search-input {
//           width: 100%;
//           max-width: 500px;
//           padding: 12px 20px;
//           border-radius: 50px;
//           border: 1px solid #666;
//           background: rgba(255, 255, 255, 0.1);
//           color: #fff;
//           transition: 0.3s ease;
//         }

//         .search-input::placeholder {
//           color: #ccc;
//         }

//         .search-input:focus {
//           outline: none;
//           background: rgba(255, 255, 255, 0.2);
//           border-color: #f39c12;
//         }

//         .glass-effect {
//           background: rgba(255, 255, 255, 0.05);
//           backdrop-filter: blur(10px);
//           border: 1px solid rgba(255, 255, 255, 0.1);
//           border-radius: 15px;
//           transition: all 0.3s ease;
//         }

//         .glass-effect:hover {
//           box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
//           transform: translateY(-6px);
//         }

//         .avatar {
//           width: 55px;
//           height: 55px;
//           border-radius: 50%;
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           font-size: 20px;
//           font-weight: 600;
//           object-fit: cover;
//         }

//         .btn-delete {
//           background: #e74c3c;
//           color: #fff;
//           border: none;
//           padding: 8px 14px;
//           border-radius: 8px;
//           margin-top: 10px;
//           transition: background 0.3s ease, transform 0.3s ease;
//         }

//         .btn-delete:hover {
//           background: #c0392b;
//           transform: scale(1.05);
//         }

//         @media (max-width: 767px) {
//           .avatar {
//             width: 45px;
//             height: 45px;
//             font-size: 16px;
//           }
//         }
//       `}</style>
//     </>
//   );
// }
